
import ShapeBottomLeft from '@/assets/svg/overlays/shape-bottom-left.svg';
import ShapeTopRight from '@/assets/svg/overlays/shape-top-right.svg';
import gsap, { ScrollTrigger } from '~/plugins/gsap';
import throttle from 'lodash/throttle';
import Vue from 'vue';
import { TransformedTmHighlight } from '~/transforms/transformModules';

export default Vue.extend({
  components: { ShapeTopRight, ShapeBottomLeft },
  props: {
    data: {
      type: Object as () => TransformedTmHighlight['data'],
      required: true,
    },
  },
  data() {
    return {
      windowWidth: null as any,
      throttledResize: null as any,
      scrollTrigger: null as any,
      scrollDir: 0 as number,
      banderole1Width: 0 as number,
      banderole2Width: 0 as number,
      banderole1Array: null as any,
      banderole2Array: null as any,
      banderole1Positions: null as any,
      banderole2Positions: null as any,
      animationLoop: null as any,
      animationMove: 0 as number,
      animationStep: 0 as number,
    };
  },
  mounted() {
    this.throttledResize = throttle(this.checkAnimation, 600);
    this.initResizeEvent();
    // WEIRD BUT WORKS
    setTimeout(() => {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.checkAnimation();
        });
      });
    }, 500);
  },

  methods: {
    getParallaxText() {
      if (this.data.highlightText?.length === 1) {
        return this.data.highlightText[0].text + '&nbsp;·&nbsp;';
      } else if ((this.data.highlightText?.length ?? 0) > 1) {
        const highlightString = this.data.highlightText?.map(str => str.text).join('&nbsp;');
        return highlightString + '&nbsp;';
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.throttledResize);
    },
    initResizeEvent() {
      window.addEventListener('resize', this.throttledResize);
    },
    checkAnimation() {
      setTimeout(() => {
        // only for getting the width
        const banderole1 = document.querySelector('.tm-highlight__overlay-banderole.first div') as HTMLElement;
        const banderole2 = document.querySelector('.tm-highlight__overlay-banderole.second div') as HTMLElement;
        if (banderole1 && banderole2) {
          const banderole1Width = banderole1.offsetWidth;
          const banderole2Width = banderole2.offsetWidth;
          if (banderole1Width !== this.banderole1Width || banderole2Width !== this.banderole2Width) {
            this.banderole1Width = banderole1Width;
            this.banderole2Width = banderole2Width;
            this.initAnimation();
          }
        }
      }, 1000);
    },

    initAnimation() {
      const module = this.$el as HTMLElement;
      // reset all
      if (this.scrollTrigger) {
        this.scrollTrigger.kill();
      }
      if (this.animationLoop) {
        cancelAnimationFrame(this.animationLoop);
      }
      this.animationMove = 0;
      this.banderole1Array = gsap.utils.toArray('.tm-highlight__overlay-banderole.first div');
      this.banderole2Array = gsap.utils.toArray('.tm-highlight__overlay-banderole.second div');
      this.banderole1Positions = [];
      for (let index = 0; index < this.banderole1Array.length; index++) {
        const element = this.banderole1Array[index] as HTMLElement;
        const elementX = element.getBoundingClientRect().left;
        this.banderole1Positions.push(elementX);
      }
      this.banderole2Positions = [];
      for (let index = 0; index < this.banderole2Array.length; index++) {
        const element = this.banderole2Array[index] as HTMLElement;
        const elementX = element.getBoundingClientRect().left;
        this.banderole1Positions.push(elementX);
      }
      // to start/stop the loop animation and change direction var:
      this.scrollTrigger = ScrollTrigger.create({
        trigger: module,

        onEnter: () => {
          gsap.to('.tm-highlight__overlay-banderole', { alpha: 0.9, duration: 1, ease: 'curveAppear' });
          this.animationLoop = requestAnimationFrame(this.frameAnimation);
        },
        onEnterBack: () => {
          gsap.to('.tm-highlight__overlay-banderole', { alpha: 0.9, duration: 1, ease: 'curveAppear' });
          this.animationLoop = requestAnimationFrame(this.frameAnimation);
        },
        onLeave: () => {
          gsap.to('.tm-highlight__overlay-banderole', { alpha: 0, duration: 1, ease: 'curveAppear' });
          cancelAnimationFrame(this.animationLoop);
        },
        onLeaveBack: () => {
          gsap.to('.tm-highlight__overlay-banderole', { alpha: 0, duration: 1, ease: 'curveAppear' });
          cancelAnimationFrame(this.animationLoop);
        },

        onUpdate: self => {
          if (this.scrollDir !== self.direction) {
            this.scrollDir = self.direction;
          }
        },
      });
    },

    updateAnimationStep() {
      if (window.innerWidth < 768) {
        this.animationStep = 0.5;
      } else {
        this.animationStep = 1;
      }
    },

    frameAnimation() {
      //
      this.updateAnimationStep();
      //
      if (this.scrollDir == 1) {
        this.animationMove += this.animationStep;
        if (this.animationMove >= this.banderole1Width) {
          this.animationMove = 0;
        }
      } else {
        this.animationMove -= this.animationStep;
        if (this.animationMove <= -this.banderole1Width) {
          this.animationMove = 0;
        }
      }

      for (let i = 0; i < this.banderole1Array.length; i++) {
        const el = this.banderole1Array[i] as HTMLElement;
        el.style.transform = 'translate(' + this.animationMove + 'px)';
      }
      for (let i = 0; i < this.banderole2Array.length; i++) {
        const el = this.banderole2Array[i] as HTMLElement;
        el.style.transform = 'translate(' + -this.animationMove + 'px)';
      }

      this.animationLoop = requestAnimationFrame(this.frameAnimation);
    },
  },
});
